(()=>{if(window.TurtlesonWardrobeLogic){window.TurtlesonWardrobeLogic.initializeAll();return;}let activeCurrency="USD";
const catalog = {
  "snapshotDate": "2026-10-08",
  "items": {
    "black": {
      "id": "black",
      "productId": "brody-quarter-zip-1",
      "handle": "brody-quarter-zip-1",
      "title": "Brody Quarter Zip",
      "color": "Black",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_BLAC_523120ae-3ff3-40b6-ad8d-18b98c0ec362.jpg?v=1786376876",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_BLAC_523120ae-3ff3-40b6-ad8d-18b98c0ec362.jpg?v=1786376876",
      "url": "/products/brody-quarter-zip-1?variant=50743094837534",
      "variants": [
        {
          "id": "50743094837534",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-S"
        },
        {
          "id": "50743094870302",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-M"
        },
        {
          "id": "50743094903070",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-L"
        },
        {
          "id": "50743094935838",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-XL"
        },
        {
          "id": "50743094968606",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-2XL"
        },
        {
          "id": "50743095001374",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-3XL"
        },
        {
          "id": "50743095034142",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-4XL"
        },
        {
          "id": "50743095066910",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-BLAC-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "duncan-stripe-performance-polo--periwinkle": {
      "id": "duncan-stripe-performance-polo--periwinkle",
      "productId": "duncan-stripe-performance-polo",
      "handle": "duncan-stripe-performance-polo",
      "title": "Duncan Stripe Cotton Polo",
      "color": "Periwinkle",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/duncan-stripe-cotton-polo-9105566.jpg?v=1776284541",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/duncan-stripe-cotton-polo-9105566.jpg?v=1776284541",
      "url": "/products/duncan-stripe-performance-polo?variant=50703554904350",
      "variants": [
        {
          "id": "50703554904350",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0535-P0089-S"
        },
        {
          "id": "50703554937118",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0535-P0089-M"
        },
        {
          "id": "50703554969886",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0535-P0089-L"
        },
        {
          "id": "50703555002654",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0535-P0089-XL"
        },
        {
          "id": "50703555035422",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0535-P0089-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-pant--shadow": {
      "id": "tide-to-tee-pant--shadow",
      "productId": "tide-to-tee-pant",
      "handle": "tide-to-tee-pant",
      "title": "Tide to Tee Pant",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-9099536.jpg?v=1776284602",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-9099536.jpg?v=1776284602",
      "url": "/products/tide-to-tee-pant?variant=50573800440094",
      "variants": [
        {
          "id": "50573800440094",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-30"
        },
        {
          "id": "50573800472862",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-32"
        },
        {
          "id": "50573800505630",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-33"
        },
        {
          "id": "50573800538398",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-34"
        },
        {
          "id": "50573800571166",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-35"
        },
        {
          "id": "50573800603934",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-36"
        },
        {
          "id": "50573800636702",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-38"
        },
        {
          "id": "50573800669470",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-40"
        },
        {
          "id": "50573800702238",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-casual-shoes": {
      "id": "black-casual-shoes",
      "title": "Navy and white spikeless golf shoes",
      "color": "Navy / white",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "olaf-brushed-twill--shadow": {
      "id": "olaf-brushed-twill--shadow",
      "productId": "olaf-brushed-twill",
      "handle": "olaf-brushed-twill",
      "title": "Olaf Brushed Twill Sport Shirt",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/olaf-brushed-twill-sport-shirt-4352439.jpg?v=1776284656",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/olaf-brushed-twill-sport-shirt-4352439.jpg?v=1776284656",
      "url": "/products/olaf-brushed-twill?variant=50078957764894",
      "variants": [
        {
          "id": "50078957732126",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 16500,
          "sku": "MTW0360-E0016-S"
        },
        {
          "id": "50078957764894",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-E0016-M"
        },
        {
          "id": "50078957797662",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 16500,
          "sku": "MTW0360-E0016-L"
        },
        {
          "id": "50078957830430",
          "options": {
            "Size": "XL"
          },
          "available": false,
          "priceCents": 16500,
          "sku": "MTW0360-E0016-XL"
        },
        {
          "id": "50078957863198",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-E0016-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--khaki": {
      "id": "ridge-sateen-pant--khaki",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Khaki",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756546556190",
      "variants": [
        {
          "id": "59756546523422",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-30"
        },
        {
          "id": "59756546556190",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-30"
        },
        {
          "id": "59756546588958",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-30"
        },
        {
          "id": "59756546621726",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-32"
        },
        {
          "id": "59756546654494",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-32"
        },
        {
          "id": "59756546687262",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-32"
        },
        {
          "id": "59756546720030",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-33"
        },
        {
          "id": "59756546752798",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-33"
        },
        {
          "id": "59756546785566",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-33"
        },
        {
          "id": "59756546818334",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-34"
        },
        {
          "id": "59756546851102",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-34"
        },
        {
          "id": "59756546883870",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-34"
        },
        {
          "id": "59756546916638",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-35"
        },
        {
          "id": "59756546949406",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-35"
        },
        {
          "id": "59756546982174",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-35"
        },
        {
          "id": "59756547014942",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-36"
        },
        {
          "id": "59756547047710",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-36"
        },
        {
          "id": "59756547080478",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-36"
        },
        {
          "id": "59756547113246",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-38"
        },
        {
          "id": "59756547146014",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-38"
        },
        {
          "id": "59756547178782",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-38"
        },
        {
          "id": "59756547211550",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-40"
        },
        {
          "id": "59756547244318",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-40"
        },
        {
          "id": "59756547277086",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-40"
        },
        {
          "id": "59756547309854",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-42"
        },
        {
          "id": "59756547342622",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-42"
        },
        {
          "id": "59756547375390",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-shirt-shoes": {
      "id": "black-shirt-shoes",
      "title": "Chocolate leather loafers",
      "color": "Chocolate",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "atlantic-long-sleeve-pocket-tee--white": {
      "id": "atlantic-long-sleeve-pocket-tee--white",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "White",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-8314864.jpg?v=1776284534",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-8314864.jpg?v=1776284534",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789564023070",
      "variants": [
        {
          "id": "50789564023070",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-S"
        },
        {
          "id": "50789564055838",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-M"
        },
        {
          "id": "50789564088606",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-L"
        },
        {
          "id": "50789564121374",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-XL"
        },
        {
          "id": "50789564154142",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "cedar-waxed-suede-vest--taupe": {
      "id": "cedar-waxed-suede-vest--taupe",
      "productId": "cedar-waxed-suede-vest",
      "handle": "cedar-waxed-suede-vest",
      "title": "Cedar Waxed Suede Vest",
      "color": "TAUPE",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 69500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/cedar-waxed-suede-vest-3639561.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/cedar-waxed-suede-vest-3639561.jpg?v=1786405220",
      "url": "/products/cedar-waxed-suede-vest?variant=59756561891614",
      "variants": [
        {
          "id": "59756561891614",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-S"
        },
        {
          "id": "59756561924382",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-M"
        },
        {
          "id": "59756561957150",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-L"
        },
        {
          "id": "59756561989918",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-XL"
        },
        {
          "id": "59756562022686",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--admiral": {
      "id": "ridge-sateen-pant--admiral",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Admiral",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "url": "/products/ridge-sateen-pant?variant=59756543901982",
      "variants": [
        {
          "id": "59756543869214",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-30"
        },
        {
          "id": "59756543901982",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-30"
        },
        {
          "id": "59756543934750",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-30"
        },
        {
          "id": "59756543967518",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-32"
        },
        {
          "id": "59756544000286",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-32"
        },
        {
          "id": "59756544033054",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-32"
        },
        {
          "id": "59756544065822",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-33"
        },
        {
          "id": "59756544098590",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-33"
        },
        {
          "id": "59756544131358",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-33"
        },
        {
          "id": "59756544164126",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-34"
        },
        {
          "id": "59756544196894",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-34"
        },
        {
          "id": "59756544229662",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-34"
        },
        {
          "id": "59756544262430",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-35"
        },
        {
          "id": "59756544295198",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-35"
        },
        {
          "id": "59756544327966",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-35"
        },
        {
          "id": "59756544360734",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-36"
        },
        {
          "id": "59756544393502",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-36"
        },
        {
          "id": "59756544426270",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-36"
        },
        {
          "id": "59756544459038",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-38"
        },
        {
          "id": "59756544491806",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-38"
        },
        {
          "id": "59756544524574",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-38"
        },
        {
          "id": "59756544557342",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-40"
        },
        {
          "id": "59756544590110",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-40"
        },
        {
          "id": "59756544622878",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-40"
        },
        {
          "id": "59756544655646",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-42"
        },
        {
          "id": "59756544688414",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-42"
        },
        {
          "id": "59756544721182",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-jacket-shoes": {
      "id": "black-jacket-shoes",
      "title": "Snuff suede Chelsea boots",
      "color": "Snuff brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "academy": {
      "id": "academy",
      "productId": "brody-quarter-zip-1",
      "handle": "brody-quarter-zip-1",
      "title": "Brody Quarter Zip",
      "color": "Academy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_B0646_bb0358f3-dc93-43e5-a02d-0c71a4b6ec6b.jpg?v=1786376876",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_B0646_bb0358f3-dc93-43e5-a02d-0c71a4b6ec6b.jpg?v=1786376876",
      "url": "/products/brody-quarter-zip-1?variant=50743094575390",
      "variants": [
        {
          "id": "50743094575390",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-S"
        },
        {
          "id": "50743094608158",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-M"
        },
        {
          "id": "50743094640926",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-L"
        },
        {
          "id": "50743094673694",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-XL"
        },
        {
          "id": "50743094706462",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-2XL"
        },
        {
          "id": "50743094739230",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-3XL"
        },
        {
          "id": "50743094771998",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-4XL"
        },
        {
          "id": "50743094804766",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-B0646-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "turtle-swagger-pocket-tee--white": {
      "id": "turtle-swagger-pocket-tee--white",
      "productId": "turtle-swagger-pocket-tee",
      "handle": "turtle-swagger-pocket-tee",
      "title": "Turtle Swagger Pocket Tee",
      "color": "White",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/turtle-swagger-pocket-tee-5676679.jpg?v=1776284529",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/turtle-swagger-pocket-tee-5676679.jpg?v=1776284529",
      "url": "/products/turtle-swagger-pocket-tee?variant=50789561041182",
      "variants": [
        {
          "id": "50789560910110",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0425-WHIT-S"
        },
        {
          "id": "50789560942878",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0425-WHIT-M"
        },
        {
          "id": "50789560975646",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0425-WHIT-L"
        },
        {
          "id": "50789561008414",
          "options": {
            "Size": "XL"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0425-WHIT-XL"
        },
        {
          "id": "50789561041182",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7000,
          "sku": "MTK0425-WHIT-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-casual-jeans": {
      "id": "academy-casual-jeans",
      "title": "Your faded blue jeans",
      "color": "Faded blue",
      "ownership": "closet",
      "isDenim": true,
      "fromYourCloset": true,
      "icon": "denim",
      "active": true
    },
    "academy-casual-shoes": {
      "id": "academy-casual-shoes",
      "title": "Cream canvas low-top sneakers",
      "color": "Cream",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "market-sportshirt--white-luxe-blue": {
      "id": "market-sportshirt--white-luxe-blue",
      "productId": "market-sportshirt",
      "handle": "market-sportshirt",
      "title": "Market Cotton Sport Shirt",
      "color": "White / Luxe Blue",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-7107226.jpg?v=1784635688",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-7107226.jpg?v=1784635688",
      "url": "/products/market-sportshirt?variant=50078951440670",
      "variants": [
        {
          "id": "50078951440670",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0013-S"
        },
        {
          "id": "50078951473438",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0350-W0013-M"
        },
        {
          "id": "50078951506206",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0350-W0013-L"
        },
        {
          "id": "50078951538974",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0013-XL"
        },
        {
          "id": "50078951571742",
          "options": {
            "Size": "2XL"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0350-W0013-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "bristol-brushed-twill-hybrid-5-pocket--stone": {
      "id": "bristol-brushed-twill-hybrid-5-pocket--stone",
      "productId": "bristol-brushed-twill-hybrid-5-pocket",
      "handle": "bristol-brushed-twill-hybrid-5-pocket",
      "title": "Bristol Twill Hybrid 5-Pocket Pant",
      "color": "Stone",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2969486.jpg?v=1789638308",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2969486.jpg?v=1789638308",
      "url": "/products/bristol-brushed-twill-hybrid-5-pocket?variant=12551735935064",
      "variants": [
        {
          "id": "12551735869528",
          "options": {
            "Size": "32"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-STON-32"
        },
        {
          "id": "12551735902296",
          "options": {
            "Size": "33"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-STON-33"
        },
        {
          "id": "12551735935064",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-STON-34"
        },
        {
          "id": "12551735967832",
          "options": {
            "Size": "35"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-STON-35"
        },
        {
          "id": "12551736000600",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-STON-36"
        },
        {
          "id": "12551736033368",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-STON-38"
        },
        {
          "id": "12551736066136",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-STON-40"
        },
        {
          "id": "12551736098904",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-STON-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-shirt-shoes": {
      "id": "academy-shirt-shoes",
      "title": "Dark brown leather penny loafers",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "grady-polo--pearl": {
      "id": "grady-polo--pearl",
      "productId": "grady-polo",
      "handle": "grady-polo",
      "title": "Grady Polo",
      "color": "Pearl",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_PEAR_b0176321-0513-44db-bcdd-691c5bac1363.jpg?v=1786376852",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_PEAR_b0176321-0513-44db-bcdd-691c5bac1363.jpg?v=1786376852",
      "url": "/products/grady-polo?variant=59738284392734",
      "variants": [
        {
          "id": "59738284327198",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-S"
        },
        {
          "id": "59738284359966",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-M"
        },
        {
          "id": "59738284392734",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-L"
        },
        {
          "id": "59738284425502",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-XL"
        },
        {
          "id": "59738284458270",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-2XL"
        },
        {
          "id": "59738284491038",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-3XL"
        },
        {
          "id": "59738284523806",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-4XL"
        },
        {
          "id": "59738284556574",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-PEAR-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "essex-suede-vest--blue-steel": {
      "id": "essex-suede-vest--blue-steel",
      "productId": "essex-suede-vest",
      "handle": "essex-suede-vest",
      "title": "Essex Suede Vest",
      "color": "BLUE STEEL",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 69500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/essex-suede-vest-9509229.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/essex-suede-vest-9509229.jpg?v=1786405220",
      "url": "/products/essex-suede-vest?variant=59756561727774",
      "variants": [
        {
          "id": "59756561727774",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-S"
        },
        {
          "id": "59756561760542",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-M"
        },
        {
          "id": "59756561793310",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-L"
        },
        {
          "id": "59756561826078",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-XL"
        },
        {
          "id": "59756561858846",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--taupe": {
      "id": "ridge-sateen-pant--taupe",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Taupe",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5695021.png?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5695021.png?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756545671454",
      "variants": [
        {
          "id": "59756545638686",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-30"
        },
        {
          "id": "59756545671454",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-30"
        },
        {
          "id": "59756545704222",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-30"
        },
        {
          "id": "59756545736990",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-32"
        },
        {
          "id": "59756545769758",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-32"
        },
        {
          "id": "59756545802526",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-32"
        },
        {
          "id": "59756545835294",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-33"
        },
        {
          "id": "59756545868062",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-33"
        },
        {
          "id": "59756545900830",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-33"
        },
        {
          "id": "59756545933598",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-34"
        },
        {
          "id": "59756545966366",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-34"
        },
        {
          "id": "59756545999134",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-34"
        },
        {
          "id": "59756546031902",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-35"
        },
        {
          "id": "59756546064670",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-35"
        },
        {
          "id": "59756546097438",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-35"
        },
        {
          "id": "59756546130206",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-36"
        },
        {
          "id": "59756546162974",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-36"
        },
        {
          "id": "59756546195742",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-36"
        },
        {
          "id": "59756546228510",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-38"
        },
        {
          "id": "59756546261278",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-38"
        },
        {
          "id": "59756546294046",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-38"
        },
        {
          "id": "59756546326814",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-40"
        },
        {
          "id": "59756546359582",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-40"
        },
        {
          "id": "59756546392350",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-40"
        },
        {
          "id": "59756546425118",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-42"
        },
        {
          "id": "59756546457886",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-42"
        },
        {
          "id": "59756546490654",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-jacket-shoes": {
      "id": "academy-jacket-shoes",
      "title": "Chocolate suede loafers",
      "color": "Chocolate",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "shadow": {
      "id": "shadow",
      "productId": "brody-quarter-zip-1",
      "handle": "brody-quarter-zip-1",
      "title": "Brody Quarter Zip",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_E0016_f6907922-488f-4a7f-8687-9f50d4db18de.jpg?v=1786376877",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0585_E0016_f6907922-488f-4a7f-8687-9f50d4db18de.jpg?v=1786376877",
      "url": "/products/brody-quarter-zip-1?variant=50743095099678",
      "variants": [
        {
          "id": "50743095099678",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-S"
        },
        {
          "id": "50743095132446",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-M"
        },
        {
          "id": "50743095165214",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-L"
        },
        {
          "id": "50743095197982",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-XL"
        },
        {
          "id": "50743095230750",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-2XL"
        },
        {
          "id": "50743095263518",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-3XL"
        },
        {
          "id": "50743095296286",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-4XL"
        },
        {
          "id": "50743095329054",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0585-E0016-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "atlantic-short-sleeve-pocket-tee--soft-sky": {
      "id": "atlantic-short-sleeve-pocket-tee--soft-sky",
      "productId": "atlantic-short-sleeve-pocket-tee",
      "handle": "atlantic-short-sleeve-pocket-tee",
      "title": "Atlantic Short Sleeve Pocket Tee",
      "color": "Soft Sky",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-short-sleeve-pocket-tee-1377286.jpg?v=1776284533",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-short-sleeve-pocket-tee-1377286.jpg?v=1776284533",
      "url": "/products/atlantic-short-sleeve-pocket-tee?variant=50789563040030",
      "variants": [
        {
          "id": "50789563040030",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7000,
          "sku": "MTK0555-B0479-S"
        },
        {
          "id": "50789563072798",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7000,
          "sku": "MTK0555-B0479-M"
        },
        {
          "id": "50789563105566",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0479-L"
        },
        {
          "id": "50789563138334",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7000,
          "sku": "MTK0555-B0479-XL"
        },
        {
          "id": "50789563171102",
          "options": {
            "Size": "2XL"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0479-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "bristol-brushed-twill-hybrid-5-pocket--navy": {
      "id": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "productId": "bristol-brushed-twill-hybrid-5-pocket",
      "handle": "bristol-brushed-twill-hybrid-5-pocket",
      "title": "Bristol Twill Hybrid 5-Pocket Pant",
      "color": "Navy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "url": "/products/bristol-brushed-twill-hybrid-5-pocket?variant=12551735083096",
      "variants": [
        {
          "id": "12551735083096",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-32"
        },
        {
          "id": "12551735115864",
          "options": {
            "Size": "33"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-33"
        },
        {
          "id": "12551735148632",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-34"
        },
        {
          "id": "12551735181400",
          "options": {
            "Size": "35"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-35"
        },
        {
          "id": "12551735214168",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-36"
        },
        {
          "id": "12551735246936",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-38"
        },
        {
          "id": "12551735279704",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-40"
        },
        {
          "id": "12551735312472",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-casual-shoes": {
      "id": "shadow-casual-shoes",
      "title": "Off-white leather low-top sneakers",
      "color": "Off-white",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "gunnar-sportshirt--stillwater": {
      "id": "gunnar-sportshirt--stillwater",
      "productId": "gunnar-sportshirt",
      "handle": "gunnar-sportshirt",
      "title": "Gunnar Cotton Sport Shirt",
      "color": "Stillwater",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-5947289.jpg?v=1784635690",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-5947289.jpg?v=1784635690",
      "url": "/products/gunnar-sportshirt?variant=50078948589854",
      "variants": [
        {
          "id": "50078948589854",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-S"
        },
        {
          "id": "50078948622622",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-M"
        },
        {
          "id": "50078948655390",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-L"
        },
        {
          "id": "50078948688158",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-XL"
        },
        {
          "id": "50078948720926",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--shadow": {
      "id": "ridge-sateen-pant--shadow",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-1923946.jpg?v=1786405286",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-1923946.jpg?v=1786405286",
      "url": "/products/ridge-sateen-pant?variant=59756544786718",
      "variants": [
        {
          "id": "59756544753950",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-30"
        },
        {
          "id": "59756544786718",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-30"
        },
        {
          "id": "59756544819486",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-30"
        },
        {
          "id": "59756544852254",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-32"
        },
        {
          "id": "59756544885022",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-32"
        },
        {
          "id": "59756544917790",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-32"
        },
        {
          "id": "59756544950558",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-33"
        },
        {
          "id": "59756544983326",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-33"
        },
        {
          "id": "59756545016094",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-33"
        },
        {
          "id": "59756545048862",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-34"
        },
        {
          "id": "59756545081630",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-34"
        },
        {
          "id": "59756545114398",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-34"
        },
        {
          "id": "59756545147166",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-35"
        },
        {
          "id": "59756545179934",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-35"
        },
        {
          "id": "59756545212702",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-35"
        },
        {
          "id": "59756545245470",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-36"
        },
        {
          "id": "59756545278238",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-36"
        },
        {
          "id": "59756545311006",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-36"
        },
        {
          "id": "59756545343774",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-38"
        },
        {
          "id": "59756545376542",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-38"
        },
        {
          "id": "59756545409310",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-38"
        },
        {
          "id": "59756545442078",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-40"
        },
        {
          "id": "59756545474846",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-40"
        },
        {
          "id": "59756545507614",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-40"
        },
        {
          "id": "59756545540382",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-42"
        },
        {
          "id": "59756545573150",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-42"
        },
        {
          "id": "59756545605918",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-shirt-shoes": {
      "id": "shadow-shirt-shoes",
      "title": "Tobacco suede loafers",
      "color": "Tobacco",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "atlantic-long-sleeve-pocket-tee--anchor": {
      "id": "atlantic-long-sleeve-pocket-tee--anchor",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "Anchor",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-3116112.jpg?v=1776284533",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-3116112.jpg?v=1776284533",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789563531550",
      "variants": [
        {
          "id": "50789563531550",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-S"
        },
        {
          "id": "50789563564318",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-M"
        },
        {
          "id": "50789563597086",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-L"
        },
        {
          "id": "50789563629854",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-XL"
        },
        {
          "id": "50789563662622",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "lance-ultra-light-vest--antique-white": {
      "id": "lance-ultra-light-vest--antique-white",
      "productId": "lance-ultra-light-vest",
      "handle": "lance-ultra-light-vest",
      "title": "Lance Ultra-Light Vest",
      "color": "Antique White",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 20000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/lance-ultra-light-vest-8123505.jpg?v=1776284538",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/lance-ultra-light-vest-8123505.jpg?v=1776284538",
      "url": "/products/lance-ultra-light-vest?variant=50703560114462",
      "variants": [
        {
          "id": "50703560114462",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 20000,
          "sku": "MTO0464-ANWH-S"
        },
        {
          "id": "50703560147230",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 20000,
          "sku": "MTO0464-ANWH-M"
        },
        {
          "id": "50703560179998",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 20000,
          "sku": "MTO0464-ANWH-L"
        },
        {
          "id": "50703560212766",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 20000,
          "sku": "MTO0464-ANWH-XL"
        },
        {
          "id": "50703560245534",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 20000,
          "sku": "MTO0464-ANWH-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--stone": {
      "id": "mbp0019-arthur-corduroy-5-pocket--stone",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Stone",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087115198750",
      "variants": [
        {
          "id": "49087115198750",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-30"
        },
        {
          "id": "49087115231518",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-32"
        },
        {
          "id": "49087115264286",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-33"
        },
        {
          "id": "49087115297054",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-34"
        },
        {
          "id": "49087115329822",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-35"
        },
        {
          "id": "49087115362590",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-36"
        },
        {
          "id": "49087115395358",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-38"
        },
        {
          "id": "49087115428126",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-40"
        },
        {
          "id": "49087115460894",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-jacket-shoes": {
      "id": "shadow-jacket-shoes",
      "title": "Dark brown leather Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    }
  },
  "products": {
    "brody-quarter-zip-1": {
      "id": "brody-quarter-zip-1",
      "title": "Brody Quarter Zip",
      "active": true,
      "licensed": false,
      "isLayer": true,
      "enabled": true,
      "colors": [
        "Black",
        "Academy",
        "Shadow"
      ],
      "anchorItems": {
        "Black": "black",
        "Academy": "academy",
        "Shadow": "shadow"
      }
    }
  }
};
const looks = [
  {
    "id": "black-casual",
    "productId": "brody-quarter-zip-1",
    "color": "Black",
    "title": "Easy layers for the back nine",
    "image": "assets/wl-brody-quarter-zip-1-black-casual-v1.jpg",
    "pieces": {
      "underlayer": "duncan-stripe-performance-polo--periwinkle",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--shadow",
      "shoes": "black-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A Periwinkle polo brings a clean collar to the black French terry with smooth bands. Shadow Tide to Tee Pant and navy and white spikeless golf shoes complete a fresh look for the course.",
    "alt": "Black Brody Quarter Zip styled with Duncan Stripe Cotton Polo in Periwinkle, Tide to Tee Pant in Shadow, Navy and white spikeless golf shoes in Navy / white. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "black-shirt",
    "productId": "brody-quarter-zip-1",
    "color": "Black",
    "title": "Texture for the workday",
    "image": "assets/wl-brody-quarter-zip-1-black-shirt-v1.jpg",
    "pieces": {
      "underlayer": "olaf-brushed-twill--shadow",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--khaki",
      "shoes": "black-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The Shadow Olaf Brushed Twill Sport Shirt adds a crisp collar beneath the black French terry with smooth bands. Khaki Ridge Sateen Pant and chocolate leather loafers give this casual office look a polished finish.",
    "alt": "Black Brody Quarter Zip styled with Olaf Brushed Twill Sport Shirt in Shadow, Ridge Sateen Pant in Khaki, Chocolate leather loafers in Chocolate. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "black-jacket",
    "productId": "brody-quarter-zip-1",
    "color": "Black",
    "title": "Quiet texture after hours",
    "image": "assets/wl-brody-quarter-zip-1-black-jacket-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--white",
      "outerlayer": "cedar-waxed-suede-vest--taupe",
      "pants": "ridge-sateen-pant--admiral",
      "shoes": "black-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Taupe Cedar Waxed Suede Vest adds tactile depth over the black French terry with smooth bands. White Atlantic Long Sleeve Pocket Tee, Admiral Ridge Sateen Pant, and snuff suede chelsea boots make the palette dinner-ready.",
    "alt": "Black Brody Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in White, Cedar Waxed Suede Vest in TAUPE, Ridge Sateen Pant in Admiral, Snuff suede Chelsea boots in Snuff brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "academy-casual",
    "productId": "brody-quarter-zip-1",
    "color": "Academy",
    "title": "Easygoing from coffee to lunch",
    "image": "assets/wl-brody-quarter-zip-1-academy-casual-v1.jpg",
    "pieces": {
      "underlayer": "turtle-swagger-pocket-tee--white",
      "outerlayer": null,
      "pants": "academy-casual-jeans",
      "shoes": "academy-casual-shoes"
    },
    "accessories": [],
    "denimApproved": true,
    "description": "A White tee keeps the Academy blue French terry relaxed; your faded blue jeans and cream canvas low-top sneakers make it easy for a weekend afternoon.",
    "alt": "Academy Brody Quarter Zip styled with Turtle Swagger Pocket Tee in White, Your faded blue jeans in Faded blue, Cream canvas low-top sneakers in Cream. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "academy-shirt",
    "productId": "brody-quarter-zip-1",
    "color": "Academy",
    "title": "Easy polish at the office",
    "image": "assets/wl-brody-quarter-zip-1-academy-shirt-v1.jpg",
    "pieces": {
      "underlayer": "market-sportshirt--white-luxe-blue",
      "outerlayer": null,
      "pants": "bristol-brushed-twill-hybrid-5-pocket--stone",
      "shoes": "academy-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The White / Luxe Blue Market Cotton Sport Shirt adds a crisp collar beneath the Academy blue French terry. Stone Bristol Twill Hybrid 5-Pocket Pant and dark brown leather penny loafers give this casual office look a polished finish.",
    "alt": "Academy Brody Quarter Zip styled with Market Cotton Sport Shirt in White / Luxe Blue, Bristol Twill Hybrid 5-Pocket Pant in Stone, Dark brown leather penny loafers in Dark brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "academy-jacket",
    "productId": "brody-quarter-zip-1",
    "color": "Academy",
    "title": "An easy evening finish",
    "image": "assets/wl-brody-quarter-zip-1-academy-jacket-v1.jpg",
    "pieces": {
      "underlayer": "grady-polo--pearl",
      "outerlayer": "essex-suede-vest--blue-steel",
      "pants": "ridge-sateen-pant--taupe",
      "shoes": "academy-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Blue Steel Essex Suede Vest adds tactile depth over the Academy blue French terry. Pearl Grady Polo, Taupe Ridge Sateen Pant, and chocolate suede loafers make the palette dinner-ready.",
    "alt": "Academy Brody Quarter Zip styled with Grady Polo in Pearl, Essex Suede Vest in BLUE STEEL, Ridge Sateen Pant in Taupe, Chocolate suede loafers in Chocolate. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "shadow-casual",
    "productId": "brody-quarter-zip-1",
    "color": "Shadow",
    "title": "A relaxed weekend uniform",
    "image": "assets/wl-brody-quarter-zip-1-shadow-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-short-sleeve-pocket-tee--soft-sky",
      "outerlayer": null,
      "pants": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "shoes": "shadow-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A Soft Sky tee keeps the gray French terry with smooth bands relaxed; Navy Bristol Twill Hybrid 5-Pocket Pant and off-white leather low-top sneakers make it easy for a weekend afternoon.",
    "alt": "Shadow Brody Quarter Zip styled with Atlantic Short Sleeve Pocket Tee in Soft Sky, Bristol Twill Hybrid 5-Pocket Pant in Navy, Off-white leather low-top sneakers in Off-white. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "shadow-shirt",
    "productId": "brody-quarter-zip-1",
    "color": "Shadow",
    "title": "A polished casual office layer",
    "image": "assets/wl-brody-quarter-zip-1-shadow-shirt-v1.jpg",
    "pieces": {
      "underlayer": "gunnar-sportshirt--stillwater",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--shadow",
      "shoes": "shadow-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The Stillwater Gunnar Cotton Sport Shirt adds a crisp collar beneath the gray French terry with smooth bands. Shadow Ridge Sateen Pant and tobacco suede loafers give this casual office look a polished finish.",
    "alt": "Shadow Brody Quarter Zip styled with Gunnar Cotton Sport Shirt in Stillwater, Ridge Sateen Pant in Shadow, Tobacco suede loafers in Tobacco. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "shadow-jacket",
    "productId": "brody-quarter-zip-1",
    "color": "Shadow",
    "title": "A considered dinner layer",
    "image": "assets/wl-brody-quarter-zip-1-shadow-jacket-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--anchor",
      "outerlayer": "lance-ultra-light-vest--antique-white",
      "pants": "mbp0019-arthur-corduroy-5-pocket--stone",
      "shoes": "shadow-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Antique White Lance Ultra-Light Vest adds tactile depth over the gray French terry with smooth bands. Anchor Atlantic Long Sleeve Pocket Tee, Stone Arthur Corduroy Pant, and dark brown leather chelsea boots make the palette dinner-ready.",
    "alt": "Shadow Brody Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in Anchor, Lance Ultra-Light Vest in Antique White, Arthur Corduroy Pant in Stone, Dark brown leather Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  }
];
function isAnchorEnabled(catalog,id){const p=catalog.products[id];return !!(p?.active&&p.enabled&&p.isLayer&&!p.licensed)}
function isEligiblePiece(item){return !!item&&(item.ownership==='closet'||(item.active&&!item.licensed))}
function validLooks(catalog,looks,productId,color){return looks.filter(l=>l.productId===productId&&l.color===color&&l.image&&Object.values(l.pieces).filter(Boolean).every(id=>isEligiblePiece(catalog.items[id]))&&l.accessories.every(id=>isEligiblePiece(catalog.items[id]))&&(!(catalog.items[l.pieces.pants]?.isDenim||l.pieces.pants==='denim')||l.denimApproved));}
function createState(catalog,looks,{productId,color,lookId,remembered={}}){
 if(!isAnchorEnabled(catalog,productId))throw Error('This layer is not enabled');
 const anchorItemId=catalog.products[productId].anchorItems[color];
 if(!anchorItemId||!isEligiblePiece(catalog.items[anchorItemId]))throw Error('Unsupported color');
 const options=validLooks(catalog,looks,productId,color);if(!options.length)throw Error('No approved look for this color');
 const chosen=options.find(l=>l.id===(lookId||remembered[`${productId}:${color}`]))||options[0];
 return {productId,color,anchorItemId,lookId:chosen.id,pieces:{...chosen.pieces},validLookIds:options.map(l=>l.id),remembered:{...remembered,[`${productId}:${color}`]:chosen.id}};
}
function changeAnchor(state,catalog,looks,next){return createState(catalog,looks,{...next,remembered:state.remembered})}
function getChoices(state,looks,role){return [...new Set(looks.filter(l=>state.validLookIds.includes(l.id)).map(l=>l.pieces[role]))]}
function choosePiece(state,looks,role,pieceId){const candidates=looks.filter(l=>state.validLookIds.includes(l.id)&&l.pieces[role]===pieceId);if(!candidates.length)throw Error('This pairing is not available');const chosen=candidates.find(l=>l.id===state.lookId)||candidates.sort((a,b)=>Object.keys(state.pieces).filter(k=>a.pieces[k]!==state.pieces[k]).length-Object.keys(state.pieces).filter(k=>b.pieces[k]!==state.pieces[k]).length)[0];return {state:{...state,lookId:chosen.id,pieces:{...chosen.pieces},remembered:{...state.remembered,[`${state.productId}:${state.color}`]:chosen.id}},changedRoles:Object.keys(state.pieces).filter(k=>k!==role&&state.pieces[k]!==chosen.pieces[k])}}
function getCoverage(catalog,looks){return Object.values(catalog.products).filter(p=>isAnchorEnabled(catalog,p.id)).flatMap(p=>p.colors.filter(c=>!validLooks(catalog,looks,p.id,c).length).map(color=>({productId:p.id,color})))}

class ImageCoordinator{
 constructor(loader){this.loader=loader;this.revision=0;this.disposed=false}
 async show(id,success,failure=()=>{}){const revision=++this.revision;try{const result=await this.loader(id);if(!this.disposed&&revision===this.revision)success(result)}catch(error){if(!this.disposed&&revision===this.revision)failure(error)}}
 destroy(){this.disposed=true;this.revision++}
}
function loadImage(src){return new Promise((resolve,reject)=>{const img=new Image();img.onload=()=>resolve(img);img.onerror=()=>reject(Error('This styled image could not load.'));img.src=src})}

function createReview(state,catalog,requestId,onlyItem){const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])];return {requestId,color:state.color,lookId:state.lookId,closetItemIds:ids.filter(id=>catalog.items[id]?.ownership==='closet'),rows:ids.filter(id=>(!onlyItem||id===onlyItem)&&catalog.items[id]?.ownership==='turtleson').map(itemId=>({itemId,included:true,quantity:1,options:{},priceCents:catalog.items[itemId].priceCents,currency:catalog.items[itemId].currency}))}}
function validateReview(review,catalog){const errors=[],lines=[];for(const row of review.rows.filter(r=>r.included)){const item=catalog.items[row.itemId];if(!isEligiblePiece(item)||item.ownership!=='turtleson'||!item.verified){errors.push('This item is not available to buy.');continue}if(!Number.isInteger(row.quantity)||row.quantity<1||row.quantity>10){errors.push('Choose a quantity from 1 to 10.');continue}const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v)&&Object.keys(row.options).every(k=>k in v.options));if(!variant){errors.push(`Choose all sizes for ${item.title||item.id}.`);continue}if(!variant.available){errors.push(`${item.title||item.id} is unavailable in that size.`);continue}if(variant.priceCents!==row.priceCents||item.currency!==row.currency){errors.push('Price changed. Please reopen the review.');continue}lines.push({itemId:item.id,variantId:variant.id,quantity:row.quantity,options:{...variant.options},priceCents:variant.priceCents,currency:item.currency,title:item.title,color:item.color,image:item.image,url:item.url})}if(!review.rows.some(r=>r.included))errors.push('Select at least one item.');if(new Set(lines.map(l=>l.currency)).size>1)errors.push('Currencies must match.');return {ok:!errors.length,errors,lines,subtotalCents:lines.reduce((n,l)=>n+l.quantity*l.priceCents,0),currency:lines[0]?.currency||'USD'}}

const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:activeCurrency,maximumFractionDigits:2}).format(cents/100);
const esc=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function icon(id){const paths={sneakers:'<path d="M12 49l14-23 14 6 8 13 30 8q14 3 12 13H10z"/><path d="M10 65h80M31 36l15 4M28 42l18 4"/>',loafers:'<path d="M10 55l12-21q15-6 26 6l12 12 22 2q11 3 8 13H10z"/><path d="M27 36l5 19 18-3M10 66h80"/>',boots:'<path d="M25 15h28l-2 31 17 7 17 3q9 2 7 12H20l-2-16z"/><path d="M20 66h72M34 18l-4 28 14 3 6-31"/>',denim:'<path d="M25 13h50l-2 25-9 42H49l1-37-10 37H25l1-42z"/><path d="M26 24h47M48 14l2 24M30 26l-2 10M65 26l4 10"/>',watch:'<path d="M43 9h16v21H43zM43 64h16v24H43z"/><circle cx="51" cy="48" r="21"/><path d="M51 35v13l10 6"/>',sunglasses:'<path d="M10 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM57 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM43 39q7-5 14 0M10 38l-6-12M90 38l6-12"/>'};return `<svg viewBox="0 0 100 100" aria-hidden="true" class="closet-icon"><g fill="${id==='denim'?'#334762':id==='sneakers'?'#fcfaf5':'#c5aa84'}" stroke="#74614b" stroke-width="2" stroke-linejoin="round">${paths[id]||paths.watch}</g></svg>`}
function itemImage(item,cls=''){return item.image?`<img class="${cls}" src="${esc(item.image)}" alt="${esc(item.title+' · '+item.color)}" loading="lazy">`:icon(item.icon||item.id)}
function swatches(state,catalog,looks){const colors=catalog.products[state.productId].colors.filter(color=>{try{createState(catalog,looks,{productId:state.productId,color});return true}catch{return false}});return `<div class="anchor-colors"><span class="color-picker-label">Explore this layer in</span><div class="swatches" role="group" aria-label="Starting layer color">${colors.map(color=>`<button type="button" class="wl-color-swatch" data-color="${esc(color)}" aria-label="${esc(color)}" title="${esc(color)}" aria-pressed="${state.color===color}"><span class="wl-color-dot" aria-hidden="true"></span></button>`).join('')}</div></div>`}
const roleNames={underlayer:'Underlayer',outerlayer:'Outer layer',pants:'Bottoms',shoes:'Shoes'};
class Studio{
 constructor(root,{catalog,looks,state,onChange,onReview,onQuickView,onColor}){Object.assign(this,{root,catalog,looks,state,onChange,onReview,onQuickView,onColor});this.images=new ImageCoordinator(loadImage);this.clickHandler=event=>this.click(event);root.addEventListener('click',this.clickHandler);this.render()}
 setState(state){this.state=state;this.render()}
 chooseLook(id){const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};this.state=createState(this.catalog,this.looks,{...this.state,lookId:id});this.onChange(this.state);this.render();this.root.getBoundingClientRect();window.scrollTo(viewport);requestAnimationFrame(()=>{if(this.root.isConnected){window.scrollTo(viewport);}})}
 click(event){const button=event.target.closest('button');if(!button)return;const {color,look,buy,retry,quickview}=button.dataset;if(quickview){this.onQuickView?.(quickview,button);return;}if(color){if(this.onColor){this.onColor(color);return;}this.state=changeAnchor(this.state,this.catalog,this.looks,{productId:this.state.productId,color});this.onChange(this.state);this.render()}else if(look)this.chooseLook(look);else if(buy)this.onReview(buy==='look'?undefined:buy);else if(retry)this.render();}
 render(){if(this.state.stylingEnabled===false){this.root.replaceChildren();return}const active=document.activeElement;const focus=active&&this.root.contains(active)?{label:active.getAttribute('aria-label'),look:active.dataset.look}:null;const state=this.state,anchor=this.catalog.items[state.anchorItemId],look=this.looks.find(l=>l.id===state.lookId),options=this.looks.filter(l=>state.validLookIds.includes(l.id)),index=options.findIndex(l=>l.id===look.id);this.root.innerHTML=`
 <div class="studio-heading"><div><p class="eyebrow">Plays well with others</p><h2>Wardrobe Logic</h2><p class="subhead">Your Brody Quarter Zip. Ready for life’s moments.</p></div><div class="anchor-lock">${itemImage(anchor)}<div><span class="eyebrow">Your starting layer · locked</span><strong>Brody Quarter Zip</strong><small>${esc(state.color)}</small>${swatches(state,this.catalog,this.looks)}</div></div></div>
 <div class="studio-body"><div class="visual-column"><div class="outfit-stage"><div class="main-scene" tabindex="0" aria-label="Styled look. Use left and right arrow keys to change look." aria-busy="true"><div class="scene-status">Preparing your look…</div><img class="outfit-photo" alt="${esc(look.alt)}" hidden><span class="scene-tag">${esc(state.color.replace(' Heather',''))} / ${String(index+1).padStart(2,'0')}</span></div><div class="alternate-rail">${options.filter(l=>l.id!==look.id).slice(0,2).map(l=>`<button data-look="${l.id}" class="alternate"><img src="${l.image}" alt="${esc(l.alt)}"><span>${esc(l.title)}</span><small>${esc(l.tier)} · View this look</small></button>`).join('')}</div></div><div class="look-caption"><button class="round" data-look="${options[(index+options.length-1)%options.length].id}" aria-label="Previous look">‹</button><div><span class="eyebrow">${String(index+1).padStart(2,'0')} / ${String(options.length).padStart(2,'0')} ways to wear it</span><h3>${esc(look.title)}</h3></div><button class="round" data-look="${options[(index+1)%options.length].id}" aria-label="Next look">›</button></div><p class="look-description">${esc(look.description)}</p><div class="look-dots" aria-label="Choose a complete look">${options.map((l,i)=>`<button data-look="${l.id}" aria-label="Look ${i+1}: ${esc(l.title)}" aria-pressed="${l.id===look.id}" class="${l.id===look.id?'active':''}"></button>`).join('')}</div></div>
 <div class="builder"><div class="builder-heading"><p class="eyebrow">Make the look yours</p><h3>In this look</h3><p>The pieces in your selected look.</p><div class="swatches layer-color-summary"><span>${esc(state.color)} · follows your selected Brody Quarter Zip</span></div></div>${Object.keys(roleNames).map(role=>this.row(role)).join('')}<button class="primary look-buy" data-buy="look">Add this look to cart <span>→</span></button><p class="buy-note">Choose your sizes first. Keep the pieces you need.</p></div></div><p class="studio-footnote">Styled imagery is illustrative. Jeans and shoes are styling suggestions from your own closet.</p><div class="sr-only studio-live" aria-live="polite"></div>`;
 const scene=this.root.querySelector('.main-scene'),photo=scene.querySelector('img'),status=scene.querySelector('.scene-status');this.images.show(look.image,img=>{photo.src=img.src;photo.hidden=false;status.hidden=true;scene.setAttribute('aria-busy','false')},()=>{status.innerHTML=`<img class="anchor-fallback" src="${esc(anchor.image)}" alt="${esc(anchor.title+' · '+anchor.color)}"><span>Your styled image is unavailable.</span><button class="text-button" data-retry="true">Try again</button>`;scene.setAttribute('aria-busy','false')});
 scene.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.chooseLook(options[(index+(e.key==='ArrowRight'?1:options.length-1))%options.length].id);this.root.querySelector('.main-scene').focus({preventScroll:true})}});
 if(focus){const buttons=Array.from(this.root.querySelectorAll('button'));const target=buttons.find(b=>focus.label&&b.getAttribute('aria-label')===focus.label)||scene;target.focus({preventScroll:true})}
 let touchStart;scene.addEventListener('touchstart',e=>touchStart=e.changedTouches[0].clientX,{passive:true});scene.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchStart;if(Math.abs(dx)>60)this.chooseLook(options[(index+(dx<0?1:options.length-1))%options.length].id)},{passive:true});
 }
 row(role){const id=this.state.pieces[role],item=this.catalog.items[id];if(!item)return '';return `<div class="piece-row" data-piece-id="${esc(id)}"><div class="row-label"><span class="eyebrow">${roleNames[role]}</span><small>${item.ownership==='closet'?'From your closet':'Turtleson'}</small></div><div class="piece-content"><div class="piece-image">${itemImage(item)}</div><div class="piece-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color||item.note||'')}</small>${item.ownership==='turtleson'?`<div class="piece-links">${this.onQuickView?`<button class="text-button view-piece" data-quickview="${esc(id)}" aria-label="Quick view ${esc(item.title)}">View piece</button>`:`<a href="${item.url}" target="_blank" rel="noopener">View piece ↗</a>`}<span>${money(item.priceCents)}</span></div>`:''}</div>${item.ownership==='turtleson'?`<button class="round add-piece" data-buy="${esc(id)}" aria-label="Add ${esc(item.title)}">＋</button>`:''}</div></div>`}
 destroy(){this.root.removeEventListener('click',this.clickHandler);this.images.destroy();this.root.replaceChildren()}
}

function hydrateItem(item, product, currency) {
  if (!product || /licensed|collegiate|ncaa|fanshop/i.test((product.tags || []).join(' '))) return {...item, active:false, verified:false, variants:[]};
  const names = product.options.map(o => typeof o === 'string' ? o : o.name);
  const colorIndex = names.findIndex(n => /^(color|colour)$/i.test(n));
  const variants = product.variants.filter(v => colorIndex < 0 || String(v.options[colorIndex]).toLowerCase() === item.color.toLowerCase()).map(v => ({id:String(v.id), options:Object.fromEntries(names.map((n,i)=>[n,v.options[i]]).filter(([n])=>!/^(color|colour)$/i.test(n))), available:v.available, priceCents:v.price, sku:v.sku}));
  const live = product.variants.find(v => variants.some(x=>x.id===String(v.id)) && v.available) || product.variants.find(v=>variants.some(x=>x.id===String(v.id)));
  return {...item,title:product.title,currency,active:variants.length>0,verified:true,variants,priceCents:live?.price || item.priceCents,image:live?.featured_image?.src || item.sourceImage,url:`${globalThis.Shopify?.routes?.root || '/'}products/${item.handle}?variant=${live?.id || ''}`};
}
function attemptStatus(cart, attempt, lines) {
  const found = (cart.items || []).filter(i=>i.properties?._wardrobe_logic_attempt===attempt);
  if (!found.length) return 'absent';
  return lines.every(l=>found.filter(i=>String(i.variant_id)===String(l.variantId)).reduce((n,i)=>n+i.quantity,0)>=l.quantity) ? 'complete':'partial';
}
async function addReviewedLook({request, root, attempt, lines, persist}) {
  const before = await request(root+'cart.js');
  const prior = attemptStatus(before,attempt,lines);
  if (prior!=='absent') return {status:prior,cart:before};
  persist({attempt,lines});
  let response, failure;
  try { response = await request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:lines.map(l=>({id:l.variantId,quantity:l.quantity,properties:{_wardrobe_logic_attempt:attempt}}))})}); } catch(e) { failure=e; }
  try {
    const cart = await request(root+'cart.js');
    const status = attemptStatus(cart,attempt,lines);
    if (status!=='absent') return {status,cart};
    if (response) return {status:'uncertain',cart};
    if (failure?.definite) return {status:'rejected',cart,message:failure.message};
    return {status:'uncertain',cart};
  } catch { return {status:'uncertain'}; }
}

function quickViewImages(item,product){
 const source=image=>{const url=typeof image==='string'?image:image?.src;return url?.startsWith('//')?'https:'+url:url;};
 const names=product.options.map(o=>typeof o==='string'?o:o.name),ci=names.findIndex(n=>/^(color|colour)$/i.test(n));
 const colorVariants=product.variants.filter(v=>ci<0||String(v.options[ci]).toLowerCase()===item.color.toLowerCase());
 const singleColor=ci<0||new Set(product.variants.map(v=>v.options[ci])).size===1;
 const images=product.images.map(source).filter(Boolean),selected=new Set(colorVariants.map(v=>source(v.featured_image)).filter(Boolean));
 const other=new Set(product.variants.filter(v=>ci>=0&&String(v.options[ci]).toLowerCase()!==item.color.toLowerCase()).map(v=>source(v.featured_image)).filter(Boolean));
 let within=false;
 const gallery=singleColor?images:images.filter(src=>{if(other.has(src)){within=false;return false;}if(selected.has(src))within=true;return within;});
 return [...new Set([source(item.image),...selected,...gallery].filter(Boolean))];
}
function quickViewVariant(item,options){return item.variants.find(v=>v.available&&Object.entries(v.options).every(([name,value])=>options[name]===value));}
function quickDescription(html){
 const doc=new DOMParser().parseFromString(html||'','text/html');
 doc.querySelectorAll('script,style,iframe,object').forEach(el=>el.remove());
 const blocks=[...doc.body.querySelectorAll('p,li,h2,h3,h4')].filter(el=>!el.querySelector('p,li')).map(el=>({tag:el.closest('li')?'li':'p',text:el.textContent.trim()})).filter(el=>el.text);
 if(!blocks.length)return `<p>${esc(doc.body.textContent.trim())}</p>`;
 return blocks.map(b=>`<${b.tag}>${esc(b.text)}</${b.tag}>`).join('').replace(/(?:<li>[\s\S]*?<\/li>)+/g,list=>`<ul>${list}</ul>`);
}
class PieceQuickView{
 constructor({host,catalog,getProduct,onReview}){
  Object.assign(this,{host,catalog,getProduct,onReview});this.version=0;this.lifetime=new AbortController();
  this.dialog=document.createElement('dialog');this.dialog.className='wl-quick-view';this.dialog.setAttribute('aria-labelledby','wl-quick-title');host.append(this.dialog);
  this.dialog.addEventListener('close',()=>{this.version++;if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});},{signal:this.lifetime.signal});
  this.dialog.addEventListener('click',e=>{const action=e.target.closest('button');if(action?.hasAttribute('data-quick-close'))this.close();if(action?.hasAttribute('data-quick-review')){const options={...this.options},id=this.item.id;this.close();this.onReview(id,options);}if(action?.hasAttribute('data-quick-retry'))this.open(this.item.id,this.trigger);if(action?.hasAttribute('data-quick-image'))this.selectPhoto(Number(action.dataset.quickImage));if(action?.hasAttribute('data-quick-step'))this.selectPhoto(this.photoIndex+Number(action.dataset.quickStep));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}},{signal:this.lifetime.signal});
  this.dialog.addEventListener('change',e=>{if(!e.target.matches('[data-quick-option]'))return;this.options[e.target.dataset.quickOption]=e.target.value;this.update();},{signal:this.lifetime.signal});
 }
 close(){this.version++;if(this.dialog.open)this.dialog.close();}
 async open(id,trigger){
  const version=++this.version;this.trigger=trigger;this.item=this.catalog.items[id];this.options={};
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p role="status">Loading the details…</p>`;
  if(!this.dialog.open)this.dialog.showModal();
  try{const product=await this.getProduct(this.item);if(version!==this.version||!this.dialog.open)return;this.item=this.catalog.items[id];if(!this.item.active||!this.item.verified)throw new Error('Unavailable');this.product=product;this.render();}catch{if(version!==this.version||!this.dialog.open)return;this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p>We couldn’t load the current details. You can try again or return to your look.</p><button class="primary" data-quick-retry>Try again</button><a class="text-button" href="${esc(this.item.url)}" target="_blank" rel="noopener">View full product details ↗</a>`;}
 }
 render(){
  const item=this.item,images=quickViewImages(item,this.product),names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">Turtleson · A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view">×</button></div><div class="quick-grid"><div class="quick-media"><div class="quick-gallery" tabindex="0" role="region" aria-label="${esc(item.title)} product photos">${images.map((src,i)=>`<img class="quick-photo" src="${esc(src)}" alt="${esc(item.title+' · '+item.color+' · Photo '+(i+1)+' of '+images.length)}" loading="${i===0?'eager':'lazy'}">`).join('')}</div>${images.length>1?`<div class="quick-gallery-controls"><button class="round" data-quick-step="-1" aria-label="Previous product photo" disabled>‹</button><span class="quick-photo-count" aria-live="polite">1 / ${images.length}</span><button class="round" data-quick-step="1" aria-label="Next product photo">›</button></div><div class="quick-thumbs" aria-label="Product photos">${images.map((src,i)=>`<button data-quick-image="${i}" aria-label="Product photo ${i+1}" aria-pressed="${i===0}"><img src="${esc(src)}" alt="" loading="lazy"></button>`).join('')}</div>`:''}</div><div class="quick-copy"><h2 id="wl-quick-title">${esc(item.title)}</h2><p class="quick-color">${esc(item.color)}</p><p class="quick-price">${money(item.priceCents)}</p><p class="quick-context">Selected to complement your Brody Quarter Zip.</p><div class="quick-options">${names.map(name=>`<label>${esc(name)}<select data-quick-option="${esc(name)}" aria-label="${esc(name)} for ${esc(item.title)}"><option value="">Select ${esc(name.toLowerCase())}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}">${esc(value)}</option>`).join('')}</select></label>`).join('')}</div><p class="quick-selection" role="status"></p><button class="primary" data-quick-review disabled>Review &amp; add this piece <span>→</span></button><button class="text-button quick-return" data-quick-close>Return to your look</button><details class="quick-description"><summary>About this piece</summary>${quickDescription(this.product.description)}</details><a class="quick-full" href="${esc(item.url)}" target="_blank" rel="noopener">View full product details ↗</a></div></div>`;
  this.photos=images;this.photoIndex=0;
  const gallery=this.dialog.querySelector('.quick-gallery');
  gallery.addEventListener('scroll',()=>{this.photoIndex=Math.max(0,Math.min(this.photos.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));this.updateGallery();},{passive:true,signal:this.lifetime.signal});
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.selectPhoto(this.photoIndex+(e.key==='ArrowRight'?1:-1));}},{signal:this.lifetime.signal});
  this.update();this.dialog.querySelector('[data-quick-close]').focus({preventScroll:true});
 }
 selectPhoto(index){
  const gallery=this.dialog.querySelector('.quick-gallery');
  this.photoIndex=Math.max(0,Math.min(this.photos.length-1,index));
  gallery.scrollTo({left:this.photoIndex*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.updateGallery();
 }
 updateGallery(){
  this.dialog.querySelectorAll('[data-quick-image]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.quickImage)===this.photoIndex)));
  const count=this.dialog.querySelector('.quick-photo-count');if(count)count.textContent=`${this.photoIndex+1} / ${this.photos.length}`;
  const previous=this.dialog.querySelector('[data-quick-step="-1"]'),next=this.dialog.querySelector('[data-quick-step="1"]');
  if(previous)previous.disabled=this.photoIndex===0;if(next)next.disabled=this.photoIndex===this.photos.length-1;
 }
 update(){
  const item=this.item,variant=quickViewVariant(item,this.options);
  this.dialog.querySelectorAll('[data-quick-option]').forEach(select=>{const name=select.dataset.quickOption;[...select.options].filter(o=>o.value).forEach(option=>{const available=item.variants.some(v=>v.available&&v.options[name]===option.value&&Object.entries(this.options).filter(([n,value])=>n!==name&&value).every(([n,value])=>v.options[n]===value));option.disabled=!available;option.textContent=option.value+(available?'':' — unavailable');});});
  this.dialog.querySelector('[data-quick-review]').disabled=!variant;
  this.dialog.querySelector('.quick-price').textContent=money(variant?.priceCents??item.priceCents);
  this.dialog.querySelector('.quick-selection').textContent=!item.variants.some(v=>v.available)?'This color is currently sold out.':variant?'Your size is available. Review it before adding.':'Choose your size to review this piece.';
 }
 destroy(){this.close();this.lifetime.abort();this.dialog.remove();}
}

const initialized = new WeakSet();
const controllers = new Map();
async function request(url, options) {
 const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
 const data = await response.json();
 if(!response.ok){const error=new Error(data.description || 'This selection could not be added.');error.definite=response.status>=400&&response.status<500;throw error;}
 return data;
}
async function initialize(host){
 if(initialized.has(host))return;initialized.add(host);
 const config=JSON.parse(host.querySelector('[data-wl-config]').textContent),rootPath=config.root,landing=config.landing;
 activeCurrency=config.currency;
 const localCatalog=structuredClone(catalog),localLooks=structuredClone(looks);
 const ui=host.querySelector('[data-wl-studio]'),reviewDialog=host.querySelector('dialog');
 for(const item of Object.values(localCatalog.items))if(item.ownership==='turtleson')item.image=item.sourceImage;
 for(const look of localLooks)look.image=config.images[look.id];
 let state,studio,review=null,returnFocus,pending=false,opening=false,revision=0,unresolved=null,queuedState=null;
 try{unresolved=JSON.parse(sessionStorage.getItem('turtleson-wl-pending')||'null');}catch{}
 const lifetime=new AbortController();let observer;controllers.set(host,()=>{revision++;lifetime.abort();observer?.disconnect();studio?.destroy();quickView?.destroy();initialized.delete(host);});
 let arrivalTimer,arrivalCleanup;
 function arriveAtStyling(){
  const destination=host.querySelector('#wardrobe');if(!destination)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header=document.querySelector('[data-section-type="header"]')||document.querySelector('header');
  const headerHeight=header?Math.max(0,header.getBoundingClientRect().bottom):100;
  const top=Math.max(0,window.scrollY+destination.getBoundingClientRect().top-headerHeight-20);
  const url=new URL(location.href);url.hash='wardrobe';history.replaceState(null,'',url);
  clearTimeout(arrivalTimer);arrivalCleanup?.();destination.classList.remove('wl-arriving');
  let finished=false;
  const finish=()=>{if(finished)return;finished=true;clearTimeout(arrivalTimer);arrivalCleanup?.();destination.focus({preventScroll:true});if(!reduced)destination.classList.add('wl-arriving');};
  arrivalCleanup=()=>window.removeEventListener('scrollend',finish);
  if(!reduced)window.addEventListener('scrollend',finish,{once:true,signal:lifetime.signal});
  window.scrollTo({top,behavior:reduced?'instant':'smooth'});
  if(reduced||Math.abs(window.scrollY-top)<2)finish();else arrivalTimer=setTimeout(finish,1600);
 }
 document.addEventListener('click',event=>{
  const link=event.target.closest('a');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  if(!link.closest('[data-wl-jump]')&&!(host.contains(link)&&link.getAttribute('href')?.endsWith('#wardrobe')))return;
  event.preventDefault();event.stopPropagation();arriveAtStyling();
 },{capture:true,signal:lifetime.signal});
 lifetime.signal.addEventListener('abort',()=>{clearTimeout(arrivalTimer);arrivalCleanup?.();});
 const detailGroup=document.querySelector('.wl-product-details');
 if(detailGroup){
  const details=[...detailGroup.querySelectorAll('.accordion')].map(accordion=>({button:accordion.querySelector('button'),panel:accordion.querySelector('.accordion__content'),inner:accordion.querySelector('.accordion__inner')})).filter(detail=>detail.button&&detail.panel&&detail.inner);
  function setDetail(detail,open){
   detail.button.setAttribute('aria-controls',detail.panel.id);
   detail.button.setAttribute('aria-expanded',String(open));
   detail.inner.dataset.open=String(open);
   detail.panel.setAttribute('aria-hidden',String(!open));
   detail.panel.style.display=open?'block':'none';
   detail.panel.style.removeProperty('height');
   detail.panel.style.removeProperty('overflow');
  }
  details.forEach(detail=>setDetail(detail,false));
  detailGroup.addEventListener('click',event=>{
   const selected=details.find(detail=>detail.button.contains(event.target));if(!selected)return;
   event.preventDefault();event.stopImmediatePropagation();
   const open=selected.button.getAttribute('aria-expanded')!=='true';
   details.forEach(detail=>setDetail(detail,detail===selected&&open));
  },{capture:true,signal:lifetime.signal});
 }
 async function refresh(ids){
  const handles=[...new Set(ids.map(id=>localCatalog.items[id].handle))];
  const products=new Map(await Promise.all(handles.map(async handle=>{try{return [handle,await request(rootPath+'products/'+handle+'.js')]}catch{return [handle,null]}})));
  for(const id of ids){const item=localCatalog.items[id];localCatalog.items[id]=hydrateItem(item,products.get(item.handle),config.currency);}
 }
 const quickView=new PieceQuickView({host,catalog:localCatalog,getProduct:async item=>{const product=await request(rootPath+'products/'+item.handle+'.js');localCatalog.items[item.id]=hydrateItem(item,product,config.currency);return product;},onReview:openReview});
 function selectedColor(){return document.querySelector('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"] .product__color-swatch.selected')?.getAttribute('data-option-value') || config.color;}
 function selectedAnchorOptions(){const selected=document.querySelector('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"] .dynamic-variant-button.selected[data-option-value]');const form=document.querySelector('[data-product-form][data-product-handle="brody-quarter-zip-1"]');const variant=Object.values(localCatalog.items).filter(i=>i.handle==='brody-quarter-zip-1').flatMap(i=>i.variants).find(v=>v.id===form?.querySelector('[name="id"]')?.value);const sizeButtons=document.querySelectorAll('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"] .product__chip.selected');return sizeButtons.length&&variant?variant.options:{};}
 function closeReview(){if(pending)return;if(reviewDialog.open)reviewDialog.close();review=null;}
 function updateState(next,push=true){revision++;closeReview();state=next;if(landing&&push){const url=new URL(location.href);url.searchParams.set('color',state.color);url.searchParams.set('look',state.lookId);history.pushState(null,'',url);}else if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}syncLinks();}
 function chooseStudioColor(color){
  if(pending)return;
  const control=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"] .product__color-swatch')).find(button=>button.dataset.optionValue===color);
  if(!control){notify('Please choose this color in the product options above.');return;}
  const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};
  control.click();
  showState(selectedColor());
  window.scrollTo(viewport);
  requestAnimationFrame(()=>{if(ui.isConnected)window.scrollTo(viewport);});
 }
 function syncLinks(){ui.querySelectorAll('.wl-color-swatch').forEach(button=>{const original=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"] .product__color-swatch')).find(control=>control.dataset.optionValue===button.dataset.color);const image=original?.querySelector('img');const dot=button.querySelector('.wl-color-dot');dot.style.backgroundColor=original?.style.backgroundColor||'';dot.style.backgroundImage=image?`url("${image.currentSrc||image.src}")`:'';});const preview=new URL(location.href).searchParams.get('preview_theme_id');host.querySelectorAll('a').forEach(a=>{const url=new URL(a.href,location.href);if(url.origin===location.origin&&preview)url.searchParams.set('preview_theme_id',preview);if(landing&&url.pathname.endsWith('/products/brody-quarter-zip-1')){url.searchParams.set('variant',localCatalog.items[state.anchorItemId].variants.find(v=>v.available)?.id||'');url.searchParams.set('look',state.lookId);}a.href=url;});if(landing){const hero=host.querySelector('.intro-photo img');if(hero){hero.src=config.images[state.anchorItemId+'-jacket'];hero.alt=state.color+' Brody Quarter Zip with a coordinated jacket, head cropped out';}}else{document.querySelectorAll('[data-wl-preview]').forEach(img=>{img.src=config.images[state.anchorItemId+'-'+img.dataset.wlPreview];});}}
 function showState(color,look){revision++;if(pending){queuedState={color,look};return;}closeReview();quickView.close();try{const next=createState(localCatalog,localLooks,{productId:"brody-quarter-zip-1",color,lookId:look,remembered:state?.remembered||{}});state=next;host.hidden=false;host.querySelector('[data-wl-title]')?.remove();if(studio)studio.setState(state);else studio=new Studio(ui,{catalog:localCatalog,looks:localLooks,state,onChange:next=>{updateState(next);queueMicrotask(syncLinks);},onReview:openReview,onQuickView:(id,trigger)=>quickView.open(id,trigger),onColor:landing?undefined:chooseStudioColor});syncLinks();if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=false;}catch{host.hidden=false;studio?.destroy();studio=null;state=null;ui.innerHTML=`<div class="studio-heading"><div><p class="eyebrow">Wardrobe Logic / Brody Quarter Zip</p><h2>More ways to wear it.</h2><p class="subhead">Choose your stock Brody Quarter Zip color to explore three considered looks.</p><p>Choose a color below to explore its coordinated looks.</p>${swatches({productId:"brody-quarter-zip-1",color},localCatalog,localLooks)}</div></div>`;ui.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>chooseStudioColor(button.dataset.color)));const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=true;}}
 async function openReview(onlyItem,selectedOptions){
  if(opening||pending)return;if(unresolved){showRecovery();return;}opening=true;returnFocus=document.activeElement;const version=revision;
  const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])].filter(id=>localCatalog.items[id]?.ownership==='turtleson');
  notify('Checking sizes and availability…');await refresh(ids);opening=false;if(version!==revision)return;
  review=createReview(state,localCatalog,crypto.randomUUID(),onlyItem);
  const chosen=review.rows.find(row=>row.itemId===onlyItem);if(chosen&&selectedOptions)chosen.options={...selectedOptions};
  const anchor=review.rows.find(r=>r.itemId===state.anchorItemId);if(anchor&&!landing)anchor.options={...selectedAnchorOptions()};
  review.closetItemIds=[...new Set([...review.closetItemIds,...(localLooks.find(l=>l.id===review.lookId)?.accessories||[])])];
  renderReview();reviewDialog.showModal();
 }
 function notify(message){const toast=host.querySelector('.toast');toast.textContent=message;toast.hidden=false;clearTimeout(notify.timer);notify.timer=setTimeout(()=>toast.hidden=true,5000);}
 function renderReview(){reviewDialog.innerHTML=`<div class="dialog-heading"><div><p class="eyebrow">Make the look yours</p><h2 id="review-title">A few good choices.</h2><p>${esc(review.color)} · ${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</p></div><button class="round close-review" aria-label="Close outfit review">×</button></div>${review.lookId?`<div class="review-look"><img src="${esc(localLooks.find(l=>l.id===review.lookId)?.image)}" alt="${esc(localLooks.find(l=>l.id===review.lookId)?.alt)}"><div><span class="eyebrow">Your look</span><h3>${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</h3><p>Start with your Brody Quarter Zip.<br>Add only what you need.</p></div></div>`:''}<p class="review-intro">Choose sizes for the pieces you want. Already own something? Simply leave it out.</p><div class="review-rows">${review.rows.map((row,i)=>{const item=localCatalog.items[row.itemId];const names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];return `<div class="review-row ${!row.included?'excluded':''}"><label class="include-label"><input type="checkbox" data-include="${i}" ${row.included?'checked':''}><span class="sr-only">Include ${esc(item.title)}</span></label><div class="review-image">${itemImage(item)}</div><div class="review-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color)} · <span data-wl-row-price="${i}">${money(row.priceCents)}</span></small><div class="review-options">${names.map(name=>`<label>${name}<select data-row="${i}" data-option="${name}" aria-label="${esc(item.title+' '+name)}" ${!row.included?'disabled':''}><option value="">Choose ${name.toLowerCase()}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}" ${!item.variants.some(v=>v.available&&v.options[name]===value)?'disabled':''} ${row.options[name]===value?'selected':''}>${esc(value)}${!item.variants.some(v=>v.available&&v.options[name]===value)?' — sold out':''}</option>`).join('')}</select></label>`).join('')}<label>Qty<select data-quantity="${i}" aria-label="${esc(item.title)} quantity" ${!row.included?'disabled':''}>${[1,2,3,4,5].map(n=>`<option ${row.quantity===n?'selected':''}>${n}</option>`).join('')}</select></label></div></div></div>`}).join('')}</div><div class="review-closet"><span>Already in your wardrobe</span><p>${review.closetItemIds.map(id=>esc(localCatalog.items[id].title)).join(' · ')||'No additional closet references in this selection.'}</p><p>Styling inspiration only. These won't be added to your bag.</p></div><div id="review-error" class="form-error" role="alert"></div><div class="review-bottom"><div><small>Selected pieces</small><strong id="review-subtotal"></strong><small>Shipping and taxes calculated at checkout.</small></div><button class="primary confirm-add">Add selected to cart <span>→</span></button></div><p class="preview-disclaimer">Only your selected Turtleson pieces are added. <a href="${rootPath}cart">View your cart ↗</a></p>`;reviewDialog.querySelector('.close-review').onclick=closeReview;reviewDialog.querySelectorAll('[data-include]').forEach(input=>input.onchange=()=>{review.rows[Number(input.dataset.include)].included=input.checked;renderReview();reviewDialog.querySelector(`[data-include="${input.dataset.include}"]`).focus()});reviewDialog.querySelectorAll('[data-option]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.row)].options[select.dataset.option]=select.value;updateSubtotal()});reviewDialog.querySelectorAll('[data-quantity]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.quantity)].quantity=Number(select.value);updateSubtotal()});reviewDialog.querySelector('.confirm-add').onclick=confirmAdd;updateSubtotal()}

 function updateSubtotal(){if(!review)return;for(const row of review.rows){const item=localCatalog.items[row.itemId];const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v));row.priceCents=variant?.priceCents||item.priceCents;}const total=review.rows.filter(r=>r.included).reduce((n,r)=>n+r.priceCents*r.quantity,0);review.rows.forEach((r,i)=>{const el=reviewDialog.querySelector('[data-wl-row-price="'+i+'"]');if(el)el.textContent=money(r.priceCents);});reviewDialog.querySelector('#review-subtotal').textContent=money(total);reviewDialog.querySelector('.confirm-add').disabled=pending||review.uncertain||!validateReview(review,localCatalog).ok;reviewDialog.querySelector('#review-error').textContent='';}
 async function confirmAdd(){
  if(pending||!review||review.uncertain||unresolved)return;const result=validateReview(review,localCatalog);const error=reviewDialog.querySelector('#review-error');if(!result.ok){error.textContent=[...new Set(result.errors)].join(' ');return;}
  pending=true;reviewDialog.querySelectorAll('button,select,input').forEach(el=>el.disabled=true);error.textContent='Confirming current prices and availability…';
  try{
   await refresh(review.rows.filter(r=>r.included).map(r=>r.itemId));
   const checked=validateReview(review,localCatalog);if(!checked.ok){pending=false;renderReview();errorAfterRender(checked.errors.join(' '));return;}
   const added=await addReviewedLook({request,root:rootPath,attempt:review.requestId,lines:checked.lines,persist:value=>{unresolved=value;try{sessionStorage.setItem('turtleson-wl-pending',JSON.stringify(value))}catch{}}});
   if(added.status==='complete'){unresolved=null;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{};pending=false;closeReview();notify(`${checked.lines.reduce((n,l)=>n+l.quantity,0)} pieces added to your cart.`);refreshCart(added.cart);}
   else if(added.status==='rejected'){unresolved=null;pending=false;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{}renderReview();errorAfterRender(added.message);}
   else{pending=false;review.uncertain=true;renderReview();errorAfterRender(added.status==='partial'?'Some pieces were added. Review your cart before adding the remaining pieces.':'We could not confirm the full addition. Check your cart before trying again.');refreshCart(added.cart,false);}
  }catch(e){pending=false;renderReview();errorAfterRender(e.message || 'Please check your connection and try again.');}finally{if(!pending&&queuedState){const next=queuedState;queuedState=null;showState(next.color,next.look);}}
 }
 function errorAfterRender(message){reviewDialog.querySelector('#review-error').textContent=message;}
 function showRecovery(){returnFocus=document.activeElement;reviewDialog.innerHTML=`<div class="dialog-heading"><h2 id="review-title">Check your cart.</h2><button class="round close-recovery" aria-label="Close cart review">×</button></div><p class="review-intro">Your earlier addition needs a quick review. Check which pieces are already in your cart before adding anything else.</p><a class="primary" href="${rootPath}cart">View my cart ↗</a><p class="review-intro"><label><input type="checkbox" class="checked-cart"> I’ve reviewed the pieces in my cart.</label></p><button class="primary resume-styling" disabled>Continue styling →</button><p class="form-error" role="alert"></p>`;reviewDialog.querySelector('.close-recovery').onclick=closeReview;const checkbox=reviewDialog.querySelector('.checked-cart'),button=reviewDialog.querySelector('.resume-styling');checkbox.onchange=()=>button.disabled=!checkbox.checked;button.onclick=async()=>{button.disabled=true;try{await request(rootPath+'cart.js');unresolved=null;sessionStorage.removeItem('turtleson-wl-pending');closeReview();}catch{reviewDialog.querySelector('.form-error').textContent='Your cart could not be reached. Please try again when your connection returns.';button.disabled=false;}};reviewDialog.showModal();}
 function refreshCart(cart,open=true){document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));if(cart)document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);if(open)setTimeout(()=>{const trigger=document.querySelector('a[aria-label="Open cart modal"]');if(trigger)trigger.click();else location.assign(rootPath+'cart');},350);}
 reviewDialog.addEventListener('cancel',event=>{if(pending)event.preventDefault()});reviewDialog.addEventListener('close',()=>{if(pending)return;review=null;if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});else ui.querySelector('.look-buy')?.focus({preventScroll:true});});
 reviewDialog.addEventListener('click',e=>{if(e.target===reviewDialog){const rect=reviewDialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)closeReview();}});
 await refresh(Object.keys(localCatalog.items).filter(id=>localCatalog.items[id].ownership==='turtleson'));
 const query=new URL(location.href).searchParams;const color=landing?(localCatalog.products["brody-quarter-zip-1"].colors.includes(query.get('color'))?query.get('color'):"Black"):selectedColor();showState(color,query.get('look'));
 if(!landing){const check=()=>{const color=selectedColor();if(color!==state?.color)showState(color);};document.addEventListener('change',()=>setTimeout(check,0),{capture:true,signal:lifetime.signal});document.addEventListener('click',event=>{if(event.target.closest('.product__color-swatch'))setTimeout(check,80);},{signal:lifetime.signal});document.addEventListener('product:variant-change',()=>setTimeout(check,0),{signal:lifetime.signal});const target=document.querySelector('[data-section-type="product"][data-product-handle="brody-quarter-zip-1"]');if(target){observer=new MutationObserver(check);observer.observe(target,{subtree:true,attributes:true,attributeFilter:['class']});}}
 else window.addEventListener('popstate',()=>{const q=new URL(location.href).searchParams;showState(localCatalog.products["brody-quarter-zip-1"].colors.includes(q.get('color'))?q.get('color'):"Black",q.get('look'));},{signal:lifetime.signal});
 try{if(unresolved){const current=await request(rootPath+'cart.js');if(attemptStatus(current,unresolved.attempt,unresolved.lines)==='complete'){sessionStorage.removeItem('turtleson-wl-pending');unresolved=null;}else notify('An earlier addition needs review. Check your cart before adding another look.');}}catch{}
}
function initializeAll(){document.querySelectorAll('[data-wardrobe-logic]').forEach(host=>initialize(host).catch(()=>{host.querySelector('[data-wl-studio]').innerHTML='<p>Wardrobe Logic is temporarily unavailable. Please refresh the page.</p>';}));}
window.TurtlesonWardrobeLogic={initializeAll};
initializeAll();document.addEventListener('shopify:section:load',initializeAll);

document.addEventListener('shopify:section:unload',event=>{for(const [host,dispose] of controllers)if(event.target.contains(host)){dispose();controllers.delete(host);}});

})();
